import IMAGES from "@/data/assetData";
import { COMPANY } from "@/data/company";
import Image from "next/image";
import Link from "next/link";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="flex flex-col bg-black bg-[url('/images/sukuto_icon_bg.svg')] bg-no-repeat bg-right bg-contain max-[844px]:bg-center max-[844px]:bg-[length:170%_100%] max-[844px]:z-[9] max-[844px]:relative">
        {/* text-gray-400 (#9ca3af), not gray-500: gray-500 on black is 4.34:1,
            which fails WCAG AA (4.5:1) for the 14px links below. gray-400 is ~8.3:1. */}
        <div className="grid grid-cols-4 max-[844px]:flex max-[844px]:flex-col text-gray-400 py-5 px-[4%] pb-2.5">
          <div className="py-2.5 max-[844px]:py-2.5 max-[844px]:text-center w-[400px] max-[844px]:w-auto">
            <div className="flex flex-row items-center pb-4 max-[844px]:justify-center">
              <div className="text-base text-white pr-2.5">
                <Image src={IMAGES.logo_icon} alt="Sukuto Icon" width={40} height={40} />
              </div>
              <span className="text-base text-white">{COMPANY.shortName}</span>
            </div>
            <div className="flex items-center pb-4 text-gray-500 text-sm font-normal max-[844px]:justify-center [&_img]:opacity-50 [&_img]:ml-0.5 [&_img]:mr-2.5">
              <Image src={IMAGES.phone_svg} alt="phone" width={24} height={25} className="w-auto" />
              <span><a href={COMPANY.phoneHref}>{COMPANY.phone}</a></span>
            </div>
            <div className="flex items-center pb-4 text-gray-500 text-sm font-normal max-[844px]:justify-center [&_img]:opacity-50 [&_img]:ml-0.5 [&_img]:mr-2.5">
              <Image src={IMAGES.email_svg} alt="email" width={24} height={25} className="w-auto" />
              <span><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></span>
            </div>
            <div className="flex items-center pb-4 text-gray-500 text-sm font-normal max-[844px]:justify-center [&_img]:opacity-50 [&_img]:ml-0.5 [&_img]:mr-2.5">
              <Image src={IMAGES.location_svg} alt="location" width={24} height={24} style={{ alignContent: "top" }} className="md:mb-14 w-auto" />
              <span>{COMPANY.addressLines.map((l, i) => (<span key={i}>{l}<br /></span>))}</span>
            </div>
          </div>
          <div className="py-2.5 max-[844px]:py-2.5 max-[844px]:text-center">
            <h3 className="text-base text-white mb-5 font-normal">About Sukuto</h3>
            <ul className="list-none p-0 [&_li]:mb-4 [&_li_a]:text-sm [&_li_a]:font-medium [&_li:hover]:text-white">
              <li><Link href="/about/">About Us</Link></li>
              <li><Link href="/contact/">Contact Us</Link></li>
              <li><Link href="/blog/">Blog</Link></li>
              <li><Link href="/sitemap/">Sitemap</Link></li>
            </ul>
          </div>
          <div className="py-2.5 max-[844px]:py-2.5 max-[844px]:text-center">
            <h3 className="text-base text-white mb-5 font-normal">Terms Of Use</h3>
            <ul className="list-none p-0 [&_li]:mb-4 [&_li_a]:text-sm [&_li_a]:font-medium [&_li:hover]:text-white">
              <li><Link href="/legal/terms-of-use/">Terms & Conditions</Link></li>
              <li><Link href="/legal/refund-cancellation-policy/">Cancellation & Refund Policy</Link></li>
              <li><Link href="/legal/privacy-policy/">Privacy Policy</Link></li>
              <li><Link href="/legal/copyright-policy/">IP Policy</Link></li>
            </ul>
          </div>
          <div className="py-2.5 max-[844px]:py-2.5 max-[844px]:text-center">
            <h3 className="text-base text-white mb-5 font-normal">GET OUR APP</h3>
            <div>
              <div className="relative max-[844px]:left-0 max-[844px]:text-center max-[844px]:justify-center max-[844px]:flex max-[844px]:flex-col max-[844px]:items-center">
                <Link className="flex items-center justify-around border border-white/30 rounded-card h-[50px] w-[200px] mb-2.5 font-light no-underline text-white hover:text-gray-700 [&_img]:-mr-[50px]" href="https://play.google.com/store/apps/details?id=com.sukuto.UserApp&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                  <Image src={IMAGES.googlePlay_img} alt="Google Play" width={34} height={38} style={{ width: "auto", height: "auto" }} />
                  <div>
                    <div className="text-left text-base !font-light">Get it on</div>
                    <div className="text-base font-normal">Google Play</div>
                  </div>
                </Link>
                <Link className="flex items-center justify-around border border-white/30 rounded-card h-[50px] w-[200px] mb-2.5 font-light no-underline text-white hover:text-gray-700 [&_img]:-mr-[50px]" href="https://apps.apple.com/in/app/sukuto/id6757588572" target="_blank" rel="noopener noreferrer">
                  <Image src={IMAGES.applePlay_img} alt="App Store" width={34} height={38} style={{ width: "auto", height: "auto" }} />
                  <div>
                    <div className="text-left text-base !font-light">Get it on</div>
                    <div className="text-base font-normal">App Store</div>
                  </div>
                </Link>
              </div>
            </div>
            <div className="flex justify-between w-[200px] mt-2.5 max-[844px]:mx-auto max-[844px]:mt-5 [&_a]:flex [&_a]:items-center [&_a]:justify-center [&_a]:w-10 [&_a]:h-10 [&_a]:rounded-full [&_a]:transition-opacity [&_a]:duration-300 [&_a:hover]:opacity-80 [&_a_svg]:w-6 [&_a_svg]:h-6">
              <Link href="https://www.facebook.com/sukutotravel" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="[&_svg]:text-facebook">
                <FaFacebookF />
              </Link>
              <Link href="https://www.linkedin.com/company/sukutotravel" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="[&_svg]:text-linkedin">
                <FaLinkedinIn />
              </Link>
              <Link href="https://www.instagram.com/sukutotravel" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="[&_svg]:text-instagram">
                <FaInstagram />
              </Link>
            </div>
          </div>
        </div>
        <div className="text-center py-2.5 text-white [&_h3]:text-base [&_h3]:font-bold">
          <h3>OUR PAYMENT CHANNELS</h3>
        </div>
        <div className="flex justify-center flex-wrap gap-[25px] max-[844px]:gap-[35px] py-2.5 pb-5 [&_img]:w-[25px] [&_img]:h-[25px] [&_img]:mx-2.5 [&_img]:object-contain">
          <Image src={IMAGES.pay_upi} alt="UPI" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_visa} alt="Visa" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_mastercard} alt="Mastercard" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_rupay} alt="Rupay" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_simpl} alt="Simpl" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_lazypay} alt="LazyPay" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_paypal} alt="PayPal" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_amex} alt="Amex" width={25} height={25} className="object-contain" />
          <Image src={IMAGES.pay_apple_pay} alt="Apple Pay" width={25} height={25} className="object-contain" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
